import { render, staticRenderFns } from "./RecommendationComponent.vue?vue&type=template&id=3554f74e&scoped=true&"
import script from "./RecommendationComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendationComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationComponent.vue?vue&type=style&index=0&id=3554f74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3554f74e",
  null
  
)

export default component.exports